import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { CarouselService, CarouselView, EFAStateServiceService, ScreenView } from '../../shared';

@Component({
  selector: 'carousel-location',
  template: `<poi-select-carousel selectedFilter="location"></poi-select-carousel>`,
  host: { class: 'experience-finder-ai--host-carousel-location experience-finder-ai--host-element experience-finder-ai--host-carousel' },
  viewProviders: [ CarouselService ],
  encapsulation: ViewEncapsulation.None
})
export class CarouselLocationComponent extends CarouselView implements OnInit {

  constructor(a: EFAStateServiceService, b: CarouselService) {
    super(a, b);
  }

  ngOnInit(): void {
    this.initialize(ScreenView.locationCarousel, 'location');
  }

}
